import { ChangeDetectionStrategy, Component, inject, linkedSignal } from '@angular/core';

import { MessageService, ToastMessageOptions } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { toSignal } from '@angular/core/rxjs-interop';

interface WrappedToastMessageOptions extends ToastMessageOptions {
  data?: {
    testKey?: string;
  };
}

@Component({
  selector: 'cito-doe-toast',
  imports: [Toast],
  templateUrl: './doe-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoeToastComponent {
  private messageService = inject(MessageService);
  private messages = toSignal(this.messageService.messageObserver);
  public testKey = linkedSignal(() => (this.messages() as WrappedToastMessageOptions)?.data?.testKey ?? null);

  closeHandler() {
    this.testKey.set(null);
  }
}
